const stringTemplate = (string, params) => (
  string ? (
    Object
      .keys(params)
      .reduce((template, key) => template.replace(`{{${key}}}`, params[key]), string)
  ) : ''
)

export default stringTemplate
